import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import Combobox from '@/common/CustomCombobox/Combobox/Combobox';
import { CustomFormControl } from '@/common/CustomFormControl/CustomFormControl';
import CustomFormFieldLabel from '@/common/CustomFormFieldLabel/CustomFormFieldLabel';
import './CustomCombobox.scss';

interface CustomComboboxProps {
  name: string;
  label: string;
  placeholder?: string;
  dropdownOptions: string[] | { category: string; option: string }[];
  isRequired?: boolean;
  isDisabled?: boolean;
  isReadOnly?: boolean;
  showFormValueOnly?: boolean;
}

export const CustomCombobox = ({
  name,
  label,
  placeholder = 'Select an option',
  dropdownOptions,
  isRequired = false,
  isReadOnly = false,
  showFormValueOnly = false,
  isDisabled = false,
}: CustomComboboxProps) => {
  const { trigger } = useFormContext();

  return (
    <CustomFormControl
      componentName={'Custom Combobox'}
      name={name}
      isDisabled={isDisabled}
      isReadOnly={isReadOnly}
      showFormValueOnly={showFormValueOnly}
    >
      <CustomFormFieldLabel
        label={label}
        isRequired={isRequired}
        isDisabled={isDisabled}
      />

      <Controller
        name={name}
        defaultValue={''}
        render={({ field: { value, onBlur, onChange } }) => {
          const handleChange = async (option: string) => {
            onChange(option);
            await trigger(name);
          };

          return (
            <Combobox
              value={value}
              onBlur={onBlur}
              onChange={handleChange}
              dropdownOptions={dropdownOptions}
              placeholder={placeholder}
              isRequired={isRequired}
              isDisabled={isDisabled}
            />
          );
        }}
      />
    </CustomFormControl>
  );
};

export default CustomCombobox;
